"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4002],{

/***/ 5058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductsSelection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/drinks.png
/* harmony default export */ var drinks = ({"src":"/_next/static/media/drinks.a3707949.png","height":786,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEX/6dj/7+D/7tLTqoyVa0X+69r/9Oe4loTTx63/8+LaxrjlyLl4Ryf25dbDtJfsrjKQeFuVmVltd0H516ve0MHvxFjTuKRiLxe7fyz7z6h2LZpLAAAACnRSTlPv/////v//+P7uBdiWOQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADNJREFUeJwFwYcBwCAMAzADNaEJG7r+f7QS4BzJeIJbS+Rn8NeoIbwHfJs9S36Aleymyg8fNQGTPcvZ0QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/heyevents.jpg
/* harmony default export */ var heyevents = ({"src":"/_next/static/media/heyevents.552edea1.jpg","height":784,"width":1200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAgIDAAAAAAAAAAAAAAABAgAEAxESITH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAQEBAAAAAAAAAAAAAAAAAAEAIf/aAAwDAQACEQMRAD8An1S5yquxxICjjGCoA933ERBTagcv/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/regular.png
/* harmony default export */ var regular = ({"src":"/_next/static/media/regular.388d7460.png","height":786,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAUVBMVEXA3v6WrIrL2+zA2fTUk0zLspW+rZK80ebNmijcnSzFwbDkuF+JnGlfcB3hq0Wbt6GxkDezmkJ0gRmOiynAnoKXXCPEnGqnYBfL1NzUw6nO4fTRakxFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nAXBBwLAEBAAwVWPaIk0/P+hZshKu//9Fvf56OkHXNaKCIbSvYvxANWkhpDYKPoBmBdAIIoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/team.jpg
/* harmony default export */ var team = ({"src":"/_next/static/media/team.7551b84c.jpg","height":788,"width":1200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAhEAABAgQHAAAAAAAAAAAAAAACAAEDBAURBhITITFBof/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQIAEf/aAAwDAQACEQMRAD8ApzNSDCBzJVWbJyiAztqWe5bXzc9+IiKMSJm0nN//2Q==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/shared/helpers/dates.js
var dates = __webpack_require__(47004);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FiberManualRecord.js
var FiberManualRecord = __webpack_require__(93837);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/hooks/useCardCount.js
"use client";

var CARD_WIDTH = 348;
var CARD_MARGIN = 24;
var MIN_CARDS = 1;
var MAX_CARDS = 3.5;
function useCardCount() {
    var ref = (0,react.useState)(MIN_CARDS), cardCount = ref[0], setCardCount = ref[1];
    (0,react.useEffect)(function() {
        var calculateCards = function calculateCards() {
            if (false) {}
            var screenWidth = window.innerWidth;
            var cardWithSpacing = CARD_WIDTH + CARD_MARGIN;
            var raw = (screenWidth + CARD_MARGIN) / cardWithSpacing;
            var possible = Math.floor(raw * 2) / 2;
            var count = Math.max(MIN_CARDS, Math.min(MAX_CARDS, possible));
            setCardCount(count);
        };
        calculateCards();
        window.addEventListener("resize", calculateCards);
        return function() {
            return window.removeEventListener("resize", calculateCards);
        };
    }, []);
    return cardCount;
}

;// CONCATENATED MODULE: ./src/static_pages/home/components/CardsSlider.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 34.5px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.4px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 20.16px;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3C4340 !important;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 17px\n  letter-spacing: 0.4px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n  padding: ",
        ";\n  width: fill-available;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  flex-wrap: wrap;\n  margin: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border-radius: 33px;\n  border: 1px solid #e3e4e4;\n  border-radius: 33px;\n  padding: ",
        "px;\n  white-space: nowrap;\n  font-size: 10px;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  margin: 0 4px;\n  &:hover {\n    fill: #3c4340;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  margin: 24px 12px;\n  ",
        " {\n    margin: 24px auto;\n  }\n  width: 348px !important;\n  height: 650px !important;\n  padding: ",
        "px;\n  gap: 32px;\n  border-radius: 20px;\n  background: #ffffff;\n  border-radius: 24px;\n  background: #fff;\n  box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 46px !important;\n  height: 46px !important;\n  width: 46px !important;\n  color: #e3e4e4 !important;\n  margin-left: -20px;\n  z-index: 1;\n  &:hover {\n    color: #3c4340;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 46px !important;\n  height: 46px !important;\n  width: 46px !important;\n  transform: translateY(-50%) rotate(180deg) !important;\n  color: #3c4340 !important;\n  margin-right: -20px;\n  z-index: 1;\n  &:hover {\n    color: #3c4340 !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}












function CardsSlider(param) {
    var _cards = param.cards, cards = _cards === void 0 ? [] : _cards;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var ref = (0,react.useState)(0), currentTab = ref[0], setCurrentTab = ref[1];
    var cardCount = useCardCount();
    var slidesToShow = cardCount;
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        centerMode: false,
        beforeChange: function(oldIndex, newIndex) {
            return setCurrentTab(Math.round(newIndex));
        },
        arrows: !mobile,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextIcon, {}),
        swipeToSlide: true,
        draggable: true,
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    bottom: "-40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        margin: "0px",
                        padding: 0
                    },
                    children: [
                        " ",
                        dots,
                        " "
                    ]
                })
            });
        },
        customPaging: function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-dot currentTab === i ? 'active' : ''}",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorIcon, {
                    style: {
                        fill: currentTab === i ? "#3C4340" : "#E3E4E4"
                    }
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: cards.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            priority: true,
                                            src: card.image,
                                            height: 197,
                                            width: 300,
                                            quality: 100,
                                            alt: card.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                            children: card.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                            children: card.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsWrapper, {
                                            children: card.chips.map(function(chip, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                                    children: chip
                                                }, "chip-".concat(index));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                            children: card.subtitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            my: 2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreLink, {
                                                href: card.moreLink,
                                                target: "_blank",
                                                children: card.moreLinkText
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        onClick: function() {
                                            return card.cta.onClick(card.cta.link);
                                        },
                                        variant: card.cta.variant,
                                        children: card.cta.title
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            }))
        })
    });
}
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var Description = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2());
var MoreLink = styled_components_browser_esm["default"].a(_templateObject3());
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3);
});
var Container = styled_components_browser_esm["default"].div(_templateObject5());
var ChipsWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 0);
});
var Chip = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var IndicatorIcon = (0,styled_components_browser_esm["default"])(FiberManualRecord/* default */.Z)(_templateObject8());
var Card = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject9(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var SliderWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject10());
var BackIcon = (0,styled_components_browser_esm["default"])(ArrowBackIos/* default */.Z)(_templateObject11());
var NextIcon = (0,styled_components_browser_esm["default"])(ArrowBackIos/* default */.Z)(_templateObject12());

;// CONCATENATED MODULE: ./src/static_pages/home/components/ProductsSelection.tsx

function ProductsSelection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 62.1px;\n  text-align: center;\n  ",
        " {\n    font-size: 32px;\n    text-align: center;\n    line-height: 48px;\n  }\n"
    ]);
    ProductsSelection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsSelection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  ",
        " {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    ProductsSelection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsSelection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 26.88px;\n  text-align: center;\n"
    ]);
    ProductsSelection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductsSelection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-bottom: 54px;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  .slick-arrow {\n    color: #3c4340;\n  }\n  margin: auto;\n  ",
        " {\n    width: 100%;\n    max-width: 1310px;\n    margin: 0 auto;\n  }\n"
    ]);
    ProductsSelection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












function ProductsSelection() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var router = (0,next_router.useRouter)();
    var openLink = function(link) {
        window.open(link, "_blank");
    };
    var ref = (0,dates/* currentMonthYear */.NM)(), month = ref.month, year = ref.year;
    var scrollToQF = function(link) {
        router.push(link);
    };
    var cards = [
        {
            title: t("productSelection.card1.title"),
            description: t("productSelection.card1.description"),
            image: regular,
            chips: [
                t("productSelection.card1.chips.1"),
                t("productSelection.card1.chips.2"),
                t("productSelection.card1.chips.3"),
                t("productSelection.card1.chips.4"), 
            ],
            subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                t: t,
                i18nKey: "productSelection.card1.subtitle",
                components: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                ]
            }),
            moreLink: "https://www.heycater.com/heykantine",
            moreLinkText: t("productSelection.card1.learnMoreText"),
            cta: {
                title: t("productSelection.card1.cta"),
                variant: "secondary",
                onClick: function() {
                    return openLink("https://calendly.com/food-program/beratungsgesprach-heykantine?month=".concat(year, "-").concat(month));
                },
                link: "#qf-start"
            }
        },
        {
            title: t("productSelection.card2.title"),
            description: t("productSelection.card2.description"),
            image: heyevents,
            chips: [
                t("productSelection.card2.chips.1"),
                t("productSelection.card2.chips.2"),
                t("productSelection.card2.chips.3"),
                t("productSelection.card2.chips.4"), 
            ],
            subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                t: t,
                i18nKey: "productSelection.card2.subtitle",
                components: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                ]
            }),
            moreLink: "https://www.heycater.com/events",
            moreLinkText: t("productSelection.card2.learnMoreText"),
            cta: {
                title: t("productSelection.card2.cta"),
                variant: "secondary",
                onClick: function() {
                    return openLink("https://www.heycater.com/de/event-contact");
                },
                link: "#qf-start"
            }
        },
        {
            title: t("productSelection.card3.title"),
            description: t("productSelection.card3.description"),
            image: team,
            chips: [
                t("productSelection.card3.chips.1"),
                t("productSelection.card3.chips.2"),
                t("productSelection.card3.chips.3"),
                t("productSelection.card3.chips.4"), 
            ],
            subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                t: t,
                i18nKey: "productSelection.card3.subtitle",
                components: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                ]
            }),
            moreLink: "https://www.heycater.com/de/business-catering",
            moreLinkText: t("productSelection.card3.learnMoreText"),
            cta: {
                title: t("productSelection.card3.cta"),
                variant: "secondary",
                onClick: scrollToQF,
                link: "#qf-start"
            }
        },
        {
            title: t("productSelection.card4.title"),
            description: t("productSelection.card4.description"),
            image: drinks,
            chips: [
                t("productSelection.card4.chips.1"),
                t("productSelection.card4.chips.2"),
                t("productSelection.card4.chips.3"),
                t("productSelection.card4.chips.4"), 
            ],
            subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                t: t,
                i18nKey: "productSelection.card4.subtitle",
                components: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                ]
            }),
            moreLink: "https://www.heycatermarketing.com/drink-snacks-service",
            moreLinkText: t("productSelection.card4.learnMoreText"),
            cta: {
                title: t("productSelection.card4.cta"),
                variant: "secondary",
                onClick: function() {
                    return openLink("https://calendly.com/food-program/beratungsgesprach-pantry-service?".concat(year, "-").concat(month));
                },
                link: "#qf-start"
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSelection_Title, {
                        mb: 2,
                        children: t("productSelection.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSelection_Subtitle, {
                        children: t("productSelection.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider, {
                cards: cards
            })
        ]
    });
}
var ProductsSelection_Title = (0,styled_components_browser_esm["default"])(esm.Typography)(ProductsSelection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var HeaderBox = styled_components_browser_esm["default"].div(ProductsSelection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var ProductsSelection_Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(ProductsSelection_templateObject2());
var Wrapper = styled_components_browser_esm["default"].div(ProductsSelection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});


/***/ })

}]);